import { serviceFields, lockCodeOfSystemRow } from './DictionaryFields'

import type { IFieldConfig } from '@/Core/Contracts/UI/Form'

/**
 * Поля сім'ї `LossReasonList` — причини програшу заявок, запитів і тендерів
 * (`SPEC-007` §5.1, §7.5). Порядок — як у легасі (`ListReasonLosingField.js`):
 * Назва, Код, Сортування.
 */
export const lossReasonListFields = (): Record<string, IFieldConfig> => ({
    title: {
        label: 'Назва',
        type: 'string',
        isRequired: true,
    },
    code: {
        label: 'Код',
        type: 'string',
        isRequired: true,
        depFn: lockCodeOfSystemRow,
    },
    sorting: {
        label: 'Сортування',
        type: 'number',
        defaultValue: 500,
    },
    ...serviceFields(),
})

/** Колонки легасі: Назва · Код · Сортування (`SPEC-007` §7.4). */
export const LOSS_REASON_LIST_COLUMNS = ['title', 'code', 'sorting']

/** Фільтри легасі: Ід · Назва · Код. */
export const LOSS_REASON_LIST_FILTERS = ['id', 'title', 'code']
